<style scoped>
@import url("../assets/css/question.css");
</style>

<template>
    <div :class="is_weixin || is_app?'':'common-home-content'">
        <div class="home-header" v-if="!is_weixin && !is_app">
            <button class="page-back" @click="pageback()"><span></span></button>
            <span class="title">智慧开方</span>
        </div>
        <div class="page-loading" v-show="!show">
            <div class="loading-content">
                <img src="../assets/images/page_loading.gif">
                <p class="title">正在加载...</p>
            </div>
        </div>
        <div v-show="show">
          <div class="question-content">
              <p class="question-title">{{index}}、{{title}}</p>
              <div class="question-select clearfix">
              <div class="answer-div fl">
                <button class="choice_select"
                  @click="loadquestion('no')"
                >否</button>
              </div>
              <div class="answer-div fr">
                <button class="choice_select"
                  @click="loadquestion('yes')"
                >是</button>
              </div>
            </div>
          </div>
          <button class="again-btn" @click="goBack()">重新开方</button>
        </div>
    </div>
</template>

<script>
import {deviceType} from '../utils/deviceType'
import http from '../assets/api/athenaApiConfig'
export default {
  data() {
    return {
      traceId: null,
      title: null,
      index: 0,
      is_app: deviceType.isApp,
      is_weixin: deviceType.isWeiXin,
      show: false
    };
  },
  created() {
    this.traceId = this.$route.params.trace_id;
    this.loadquestion("yes");
    window.appBack = ()=> this.pageback();
  },
  methods: {
    loadquestion(choice){
        var that = this;
        var param = {"trace": that.traceId, "choice": choice};
        http.get("/zhen/diagnose", {params: param}).then(function(res) {
            var locData = res.data;
            if(locData.question){
                that.index += 1;
                that.traceId = locData.trace;
                that.title = locData.question;
                if(!that.show) that.show = true;
            }else{
                that.$router.push({ path: locData.solution});
            }
        });
    },
    goBack(){
       var that = this;
        if(that.index > 1){
            that.$layer.confirm('“返回”将从头选择症状，以保证症状精准采集。是否继续？', {
                    btn: ['是','否'] 
            }, function(){ 
                that.$layer.closeAll();
                that.pageback();
            }, function(){
                that.$layer.closeAll();
            });
        }else{
            that.pageback();
        }
    },
    pageback(){
        window.history.back();
        return true;
    }  
  }
}
</script>

